import { useEffect } from "react";
import PackagesBase from "./PackagesBase/PackagesBase";
import { useDispatch } from "react-redux";
import { resetStateOfMonitorPackage } from "../../../../features/monitoringPackagesSlice";

const DataCollectionPackages = () => {
  const dispatch = useDispatch();
  
  //--Cleanup on unmount
  useEffect(() => {
    return () => {
      dispatch(resetStateOfMonitorPackage());
    };
  }, [dispatch]);

  return (
    <div>
      <PackagesBase />
    </div>
  );
};

export default DataCollectionPackages;
